module.exports = __webpack_public_path__ + "static/media/alert-icon.57eae3c3.svg";